import React from 'react';
import { Card } from 'antd';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from 'recharts';

const CategoryBarChart = ({ data }) => {
  // Helper function to safely get data from different possible structures
  const getCoursesByCategory = () => {
    if (!data) return [];
    
    // Try different possible data structures
    const paths = [
      'coursesByCategory',
      'data.coursesByCategory',
      'overview.coursesByCategory',
      'data.overview.coursesByCategory'
    ];
    
    for (const path of paths) {
      const value = path.split('.').reduce((obj, key) => obj?.[key], data);
      if (value && Array.isArray(value) && value.length > 0) {
        return value;
      }
    }
    
    return [];
  };

  const coursesByCategory = getCoursesByCategory();

  if (coursesByCategory.length === 0) {
    return (
      <Card title="Course Distribution by Category" className="chart-card">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div style={{ color: '#999', padding: '40px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📈</div>
            <p>No category data available yet</p>
            <p style={{ fontSize: '12px' }}>Category data will appear here when courses are created</p>
          </div>
        </div>
      </Card>
    );
  }

  const chartData = coursesByCategory
    .sort((a, b) => b.courseCount - a.courseCount) 
    .map((category, index) => ({
      name: category.categoryName,
      courses: category.courseCount,
      slug: category.categorySlug,
      rank: index + 1
    }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '10px'
        }}>
          <p style={{ margin: 0, fontWeight: 'bold' }}>
            {label}
          </p>
          <p style={{ margin: 0, color: '#666' }}>
            Courses: {payload[0].value}
          </p>
          <p style={{ margin: 0, color: '#999' }}>
            Rank: #{payload[0].payload.rank}
          </p>
        </div>
      );
    }
    return null;
  };

  // Custom active bar chỉ dài đúng bằng cột, có thể thêm hiệu ứng bo góc, đổ bóng
  const CustomActiveBar = (props) => {
    const { x, y, width, height } = props;
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill="#6c63ff"
          rx={6}
          ry={6}

        />
      </g>
    );
  };

  return (
    <Card title="Course Distribution by Category" className="chart-card">
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '380px' }}>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="name" 
              angle={-45}
              textAnchor="end"
              height={80}
              interval={0}
              tick={{ fontSize: 11 }}
            />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="courses" 
              fill="#8884d8" 
              radius={[4, 4, 0, 0]}
              maxBarSize={50}
              activeBar={<CustomActiveBar />}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default CategoryBarChart; 